import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

export interface KaraokeEntryComponentInterface {
    textEntryId: string;
}

@Component({
    selector: 'karaoke-entry',
    templateUrl: './karaoke-entry.component.html',
    styleUrls: ['./karaoke-entry.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class KaraokeEntryComponent implements KaraokeEntryComponentInterface {
    @Input('data-text-entry-id')
    public textEntryId!: string;
}
